export const INVOICE_STATUS = {
    PENDING: 'pending',
    CERTIFIED: 'certified',
    VALIDATION_ERROR: 'validationError',
    FAILED: 'failed',
    REJECTED: 'rejected',
    CANCELLED: 'cancelled',
} as const;
